import React, { useState, useEffect } from "react";
import AvatarEditor from "./lib";
import { Popover } from "antd";
import _ from "lodash";
import { FaCropAlt, FaSyncAlt } from "react-icons/fa";
const Index = (props) => {
  const isBig = !!props.big;
  const cardBorderColor = "#CFCFCF";
  const primaryButtonColor = "#34AFA9";

  let editor = React.createRef(props.keys);
  const [image, setImage] = useState("");
  const [preview, setPreview] = useState(null);
  const [width, setWidth] = useState(props.square ? 300 : 820);
  const [height, setHeight] = useState(props.square ? 300 : 392);
  const [scale, setScale] = useState(1);
  const [border, setBorder] = useState(50);
  const [borderRadius, setBorderRadius] = useState(0);
  const [maxSize, setMaxSize] = useState(2);
  const [rotate, setRotate] = useState(0);
  const [color, setColor] = useState([255, 255, 255, 0.6]);
  const [uploadShow, setUploadShow] = useState(false);
  let onMouseUp = () => {
    handleSave();
  };
  let handleScale = (e) => {
    const scale = parseFloat(e.target.value);

    setScale(scale);
    handleSave();
  };
  let rotateScale = (e) => {
    const scale = parseFloat(e.target.value);
    e.preventDefault();
    setRotate(scale);
    handleSave();
  };
  let onFileChange = (evt) => {
    var fileList = evt.target.files;
    var file = fileList;
    setImage(file);
    setUploadShow(true);
  };
  let handleSave = () => {
    const img = editor.current.getImageScaledToCanvas().toDataURL();
    const rect = editor.current.getCroppingRect();
    editor.current.getImageScaledToCanvas().toBlob((blob) => {
      setPreview({
        img,
        blob,
        rect,
        scale: scale,
        width: width,
        height: height,
        borderRadius: borderRadius,
      });
    });
  };
  let handleCancel = () => {
    setUploadShow(false);
    setPreview(null);
    props.savePreview(null);
    document.getElementById(`fileInput${props.keys}`).value = "";
  };

  let content = (
    <div style={{ width: "120px", padding: "2px 0" }}>
      <input
        type="range"
        onChange={handleScale}
        min={"1"}
        max="2"
        step="0.01"
        defaultValue="1"
        style={{ width: "100%", cursor: "pointer" }}
      />
    </div>
  );
  let content2 = (
    <div style={{ width: "120px", padding: "2px 0" }}>
      <input
        type="range"
        onChange={rotateScale}
        min="0"
        max="180"
        step="1"
        defaultValue="0"
        style={{ width: "100%", cursor: "pointer" }}
      />
    </div>
  );

  const outerStyle = {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "16px",
    padding: "12px",
    border: `1px dashed ${cardBorderColor}`,
    borderRadius: "14px",
    width: "100%",
    boxSizing: "border-box",
  };

  const previewPanelStyle = {
    background: "#E0E0E2CC",
    width: "100%",
    borderRadius: "8px",
    minHeight: isBig ? "250px" : "220px",
    padding: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
  };

  const emptyStateStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: isBig ? "220px" : "190px",
    textAlign: "center",
  };

  const actionRowStyle = {
    display: props.show ? "flex" : "none",
    width: "100%",
    justifyContent: isBig ? "flex-start" : "center",
    alignItems: "center",
  };

  const browseButtonStyle = {
    minHeight: "42px",
    width: isBig ? "40%" : "60%",
    border: "none",
    borderRadius: "0",
    backgroundColor: primaryButtonColor,
    color: "#fff",
    cursor: props.disabled ? "not-allowed" : "pointer",
    marginTop: "4px",
    opacity: props.disabled ? 0.6 : 1,
    borderRadius: "10px",
  };

  const modalOverlayStyle = {
    position: "fixed",
    inset: 0,
    zIndex: 1050,
    backgroundColor: "rgba(0, 0, 0, 0.35)",
    display: uploadShow ? "flex" : "none",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    boxSizing: "border-box",
  };

  const modalStyle = {
    background: "#fff",
    width: "100%",
    maxWidth: "1280px",
    borderRadius: "0",
    padding: "16px 16px 48px",
    boxSizing: "border-box",
    position: "relative",
    overflowX: "auto",
  };

  const closeStyle = {
    position: "absolute",
    right: "12px",
    top: "8px",
    fontSize: "24px",
    lineHeight: 1,
    color: "#34AFA9",
    cursor: "pointer",
  };

  const modalBodyStyle = {
    display: "flex",
    gap: "24px",
    alignItems: "flex-start",
    justifyContent: "space-between",
    flexWrap: "nowrap",
  };

  const editorColumnStyle = {
    flex: "1 1 auto",
    minWidth: isBig ? "920px" : "860px",
  };

  const sliderRowStyle = {
    marginTop: "10px",
    width: "100%",
    maxWidth: "400px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
  };

  const sliderActionStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#49B8B4",
    fontWeight: 700,
    cursor: "pointer",
    userSelect: "none",
  };

  const previewColumnStyle = {
    flex: `0 0 ${props.square ? 186 : 246}px`,
    width: `${props.square ? 186 : 246}px`,
    display: "flex",
    flexDirection: "column",
    marginTop: "38px",
  };

  const actionButtonBaseStyle = {
    width: "100%",
    height: "40px",
    borderRadius: "8px",
    cursor: "pointer",
    marginTop: "8px",
    fontSize: "16px",
    lineHeight: "1",
    fontWeight: 500,
  };

  const cancelButtonStyle = {
    ...actionButtonBaseStyle,
    border: "none",
    background: "#E3E3E3",
    color: "#49B8B4",
  };

  const saveButtonStyle = {
    ...actionButtonBaseStyle,
    border: "none",
    background: primaryButtonColor,
    color: "#fff",
  };

  return (
    <>
      <div style={outerStyle}>
        <div style={previewPanelStyle}>
          {!!preview ? (
            <div style={{ width: "100%", height: isBig ? "250px" : "220px" }}>
              <img
                src={preview.img}
                alt="preview"
                style={{
                  height: "100%",
                  width: "100%",
                  borderRadius: `${
                    (Math.min(preview.height, preview.width) + 10) *
                    (preview.borderRadius / 2 / 100)
                  }px`,
                  objectFit: "cover",
                  overflow: "hidden",
                }}
              />
            </div>
          ) : (
            <div style={emptyStateStyle}>
              {props.hasImg ? (
                <img
                  style={{ overflow: "hidden" }}
                  className="object-cover  w-full h-full"
                  src={props.hasImg}
                />
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ width: "84px", height: "auto" }}
                  viewBox="0 0 62.05 39.643"
                >
                  <path
                    id="icon_upload"
                    d="M50.706,16.683c0-.165.028-.33.028-.5A15.987,15.987,0,0,0,20.263,9.222,8.224,8.224,0,0,0,8.407,15.279,12.531,12.531,0,0,0,12.4,39.643h14.2V28.631H19.917L31.025,17.11,42.133,28.617H35.457V39.629H50.734a11.474,11.474,0,0,0-.028-22.946Z"
                    fill="#43425d"
                    opacity="0.1"
                  />
                </svg>
              )}
              {props.hasImg ? (
                ""
              ) : (
                <>
                  <p style={{ fontSize: "12px", margin: "16px 0 0" }}>
                    {props.title}
                  </p>
                  {props.description && (
                    <p
                      style={{
                        fontSize: "12px",
                        color: "#6c757d",
                        margin: "4px 0 0",
                      }}
                    >
                      ({props.description})
                    </p>
                  )}
                </>
              )}
            </div>
          )}
        </div>
        <input
          id={`fileInput${props.keys}`}
          type="file"
          hidden
          accept="image/*"
          onChange={onFileChange}
        />
        <div style={actionRowStyle}>
          <button
            type="button"
            disabled={props.disabled}
            style={browseButtonStyle}
            onClick={() => {
              document.getElementById(`fileInput${props.keys}`).click();
            }}
          >
            Browse files
          </button>
        </div>
      </div>
      <div style={modalOverlayStyle}>
        <div style={modalStyle}>
          <span
            style={closeStyle}
            onClick={() => {
              handleCancel();
            }}
          >
            x
          </span>
          <p
            style={{
              fontSize: "24px",
              fontWeight: 700,
              marginBottom: "12px",
              marginTop: "0",
              color: "#2d2d2d",
            }}
          >
            Crop Image
          </p>
          <div style={modalBodyStyle}>
            <div style={editorColumnStyle}>
              <AvatarEditor
                ref={editor}
                image={image}
                scale={scale}
                width={width}
                height={height}
                border={border}
                onLoadSuccess={() => {
                  handleSave();
                }}
                onMouseUp={_.throttle(onMouseUp, 100)}
                borderRadius={borderRadius}
                color={color} // RGBA
                rotate={rotate}
                crossOrigin="anonymous"
                maxSize={maxSize}
                filetype={["png", "jpg", "jpeg"]}
              />
              <div style={sliderRowStyle}>
                <Popover
                  content={content}
                  trigger={["hover", "click"]}
                  placement="topLeft"
                  mouseEnterDelay={0.05}
                  mouseLeaveDelay={0.25}
                  zIndex={2100}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                >
                  <div style={sliderActionStyle}>
                    <FaCropAlt style={{ width: "16px", height: "16px" }} />
                    <span
                      style={{
                        marginLeft: "8px",
                        fontSize: "18px",
                        fontWeight: 700,
                      }}
                    >
                      Scale
                    </span>
                  </div>
                </Popover>
                <Popover
                  content={content2}
                  trigger={["hover", "click"]}
                  placement="topLeft"
                  mouseEnterDelay={0.05}
                  mouseLeaveDelay={0.25}
                  zIndex={2100}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                >
                  <div style={{ ...sliderActionStyle, color: "#A66BEB" }}>
                    <FaSyncAlt style={{ width: "16px", height: "16px" }} />
                    <span
                      style={{
                        marginLeft: "8px",
                        fontSize: "18px",
                        fontWeight: 700,
                      }}
                    >
                      Rotate
                    </span>
                  </div>
                </Popover>
              </div>
            </div>
            <div style={previewColumnStyle}>
              {!!preview && (
                <>
                  <img
                    src={preview.img}
                    alt="preview"
                    style={{
                      width: "100%",
                      height: "186px",
                      marginTop: "0px",
                      objectFit: "cover",
                      borderRadius: `${
                        (Math.min(preview.height, preview.width) + 10) *
                        (preview.borderRadius / 2 / 100)
                      }px`,
                      border: "1px solid #ccc",
                    }}
                  />
                </>
              )}
              <button
                type="button"
                style={cancelButtonStyle}
                onClick={() => {
                  handleCancel();
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                style={saveButtonStyle}
                onClick={() => {
                  setUploadShow(false);
                  document.getElementById(`fileInput${props.keys}`).value = "";
                  props.savePreview(preview);
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
